import { render, staticRenderFns } from "./CreatorCommentStatistics.vue?vue&type=template&id=248db031&scoped=true"
import script from "./CreatorCommentStatistics.vue?vue&type=script&lang=js"
export * from "./CreatorCommentStatistics.vue?vue&type=script&lang=js"
import style0 from "./CreatorCommentStatistics.vue?vue&type=style&index=0&id=248db031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248db031",
  null
  
)

export default component.exports